import { render, staticRenderFns } from "./CaculateUPC.vue?vue&type=template&id=28a5ef3d"
import script from "./CaculateUPC.vue?vue&type=script&lang=js"
export * from "./CaculateUPC.vue?vue&type=script&lang=js"
import style0 from "./CaculateUPC.vue?vue&type=style&index=0&id=28a5ef3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports